<template>
  <b-navbar :sticky="true" toggleable="md" variant="white" type="light" class="py-0 box-shadow">
    <b-navbar-brand class="col-2 text-center mr-auto align-middle" :to="{ path: '/'}">
      <img height="35px" :src="amioLogo">
    </b-navbar-brand>
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-collapse class="col-10" is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item class="border border-white border-left-0 border-right-0 py-2 px-3"
                    :class="{ active: $route.name.startsWith('administration.channel')}"
                    :to="{ name: 'administration.channels'}">
          Channels
        </b-nav-item>

        <b-nav-item class="border border-white border-left-0 border-right-0 py-2 px-3"
                    :class="{ active: $route.name.startsWith('administration.integration')}"
                    :to="{ name: 'administration.integrations'}">
          Integrations
        </b-nav-item>

        <b-nav-item class="border border-white border-left-0 border-right-0 py-2 px-3"
                    :class="{ active: $route.name.startsWith('administration.logs')}"
                    :to="{ name: 'administration.logs'}">
          Logs
        </b-nav-item>

        <b-nav-item-dropdown text="Settings"
                             class="border border-white border-left-0 border-right-0 py-2 px-3"
                             :class="{ active: $route.name.startsWith('administration.settings')}">
          <b-dropdown-item :to="{ name: 'administration.settings.users.list'}">
            Users
          </b-dropdown-item>
          <b-dropdown-item :to="{ name: 'administration.settings.api'}">
            API
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="isAutomationEnabled"
                    class="border border-white border-left-0 border-right-0 py-2 px-3"
                    :href="automateLink">
          Automate
        </b-nav-item>

        <b-nav-item-dropdown text="Resources" class="border border-white border-left-0 border-right-0 py-2 px-3" right>
          <b-dropdown-item target="_blank" href="mailto:support@amio.io">Support</b-dropdown-item>
          <b-dropdown-item target="_blank" href="https://docs.amio.io/">Documentation</b-dropdown-item>
          <b-dropdown-item target="_blank" href="https://docs.amio.io/v1.0/reference">API</b-dropdown-item>
          <b-dropdown-item target="_blank" href="https://status.amio.io/">Status</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown class="border border-white border-left-0 border-right-0 px-3" right :no-caret="true">
          <template slot="button-content">
            <avatar color="#fff" :size="35" username="userName || userEmail"></avatar>
          </template>
          <b-dropdown-item :to="{ name: 'administration.settings.users.edit', params: {id: userId}}">
            <span>Profile</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="logout">
            <span>Log out</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
  import authService from '@/services/security/hosted-auth.service'
  import userProfileService from '@/services/security/user-profile.service'
  import {restore} from '@/config/store'
  import amioLogo from '@/assets/img/logo/amio.svg'
  import Avatar from 'vue-avatar'

  export default {
    components: {
      'avatar': Avatar
    },

    data() {
      return {
        amioLogo
      }
    },

    computed: {
      automateLink() {
        return process.env.VUE_APP_AUTOMATE_SERVER_URL
      },

      isAutomationEnabled() {
        return userProfileService.getIsAutomationEnabled()
      },

      userName() {
        return userProfileService.getUserName()
      },

      userEmail() {
        return userProfileService.getUserEmail()
      },

      userId() {
        return userProfileService.getUserId()
      }
    },

    methods: {
      logout() {
        authService.logout()
        restore()
      }
    }
  }
</script>
<style scoped lang="scss">
  .box-shadow {
    box-shadow: 0 0 95px rgba(0, 0, 0, 0.14);
  }

</style>
